import socialLevelMixin from '@/mixins/socialLevel';
import { isStandalone } from '@/mixins/userAgent';
import userDetailsMixin from '@/mixins/userDetails';

export default {
  mixins: [
    socialLevelMixin,
    userDetailsMixin,
  ],
  props: {
    comment: Object,
  },
  methods: {
    traderLevelDisplay(item) {
      const level = this.getLevelByPredictions(item.profitablePredictions);
      return `Level ${level.num} (${level.text})`;
    },
    ellipsizeTextBox(el) {
      const wordArray = el.innerHTML.split(' ');
      while (el.scrollHeight > el.offsetHeight) {
        wordArray.pop();
        el.innerHTML = `${wordArray.join(' ')}...`;
      }
    },
    onClick() {
      if (this.comment && this.comment.commentUrl && !isStandalone) {
        window.location.href = this.comment.commentUrl;
      }
    },
  },
  mounted() {
    // this.ellipsizeTextBox(this.$refs.text);
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-top-comments/top-comment/top-comment.js